import Model from "backdraft-app/src/model";

export default class Campaign extends Model {
  parse(attrs) {
    if (attrs.status === "Activated") {
      attrs.status = "Live";
    } else if (attrs.status === "Entry") {
      attrs.status = "Pending";
    } else if (attrs.status === "Expired") {
      attrs.status = "Paused";
    }

    return attrs;
  }
}
